import { render, staticRenderFns } from "./ActiveClues.vue?vue&type=template&id=72e97ce0&lang=pug&"
import script from "./ActiveClues.vue?vue&type=script&lang=js&"
export * from "./ActiveClues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports